module.exports = __webpack_public_path__ + "img/kir-royale.af19fc21.jpg";